import Component from "@glimmer/component";
import { fn } from "@ember/helper";
import { action } from "@ember/object";
import CategoryChooser from "discourse/select-kit/components/category-chooser";
import DButton from "discourse/ui-kit/d-button";
import DConditionalLoadingSpinner from "discourse/ui-kit/d-conditional-loading-spinner";
import { i18n } from "discourse-i18n";

export default class ChangeCategory extends Component {
  categoryId = 0;

  @action
  async changeCategory() {
    await this.args.forEachPerformed(
      {
        type: "change_category",
        category_id: this.categoryId,
      },
      (t) => t.set("category_id", this.categoryId)
    );
  }

  <template>
    <p>{{i18n "topics.bulk.choose_new_category"}}</p>

    <p>
      <CategoryChooser
        @onChange={{fn (mut this.categoryId)}}
        @value={{this.categoryId}}
      />
    </p>

    <DConditionalLoadingSpinner @condition={{@loading}}>
      <DButton
        @action={{this.changeCategory}}
        @label="topics.bulk.change_category"
      />
    </DConditionalLoadingSpinner>
  </template>
}
